import { BankFormState, VenueFormState } from "company/detail/components/models";
import { convertToBankFormState, convertToFormState, convertToVenueFormState, getInstruction, getUpdateVenueInstuction } from "company/detail/utils";
import { MergeSectionTemplate } from "components/MainSectionTemplate/MergeSectionTemplate";
import { CompanySidePanel } from "components/SidePanel/Company/CompanySidePanel";
import React from "react";
import { useLoaderData, useSearchParams } from "react-router";
import { routes } from "utilities/routing/generatedRoutes";
import { addressSection } from "./addressSection";
import { bankDetailsSection } from "./bankDetailsSection";
import { contactDetailsSection } from "./contactDetailsSection";
import { financialDetailsSection } from "./financialDetailsSection";
import { generalDetailsSection } from "./generalDetailsSection";
import { postalAddressSection } from "./postalAddressSection";
import { profileSection } from "./profileSection";
import { venueDetailsSection } from "./venueDetailsSection";

const CompanyMergeApp = () => {
  const viewModel = useLoaderData<server.viewmodel.CompanyMergeFrontModel>();

  const [searchParams, _] = useSearchParams();
  const fromWebformId = Number.parseInt(searchParams.get("fromWebformId"));
  const redirectUrl = fromWebformId ?
    routes.show_FromWebform(fromWebformId).absolute :
    routes.company_Detail(viewModel.targetCompany.companyId).absolute;

  const existingCompany = convertToFormState(viewModel.targetCompany);
  const existingVenue = convertToVenueFormState(viewModel.targetCompanyVenue);
  const existingBank = convertToBankFormState(viewModel.targetCompany.bank);
  const existingTags = viewModel.targetCompany.tags;

  const sourceCompany = convertToFormState(viewModel.sourceCompany);
  const sourceVenue = convertToVenueFormState(viewModel.sourceCompanyVenue);
  const sourceBank = convertToBankFormState(viewModel.sourceCompany.bank);
  const sourceTags = viewModel.sourceCompany.tags;

  const [currentCompany, setCurrentCompany] = React.useState(existingCompany);
  const [currentVenue, setCurrentVenue] = React.useState<VenueFormState>(existingVenue);
  const [currentBank, setCurrentBank] = React.useState<BankFormState>(existingBank);
  const [currentTags, setCurrentTags] = React.useState<server.dto.TagSmall[]>(existingTags);

  const venueSectionHidden = currentCompany.profile.isVenue === "no";

  return <MergeSectionTemplate
    redirectUrl={redirectUrl}
    sourceHeader={<div>
      <CompanySidePanel type="company" companyId={viewModel.sourceCompany.companyId} trigger={<a>{RESX.GeneralLabels.Source}</a>} />
      <br />
      {RESX.GeneralLabels.ThisRecordWillBeMergedWithTheExistingRecord}
    </div>}
    existingHeader={<div>
      <CompanySidePanel type="company" companyId={viewModel.targetCompany.companyId} trigger={<a>{RESX.GeneralLabels.ExistingRecord}</a>} />
      <br />
      {RESX.GeneralLabels.ThisRecordWillBeSavedInTheDatabase}
    </div>}
    submit={() => window.CoreApi.Company.Merge({
      sourceCompanyId: viewModel.sourceCompany.companyId,
      targetCompany: getInstruction(viewModel.targetCompany, currentCompany, currentBank, {}),
      targetVenue: getUpdateVenueInstuction(viewModel.targetCompany.companyId, currentVenue, {}),
    })}
    sections={[
      addressSection(existingCompany, sourceCompany, currentCompany, setCurrentCompany),
      postalAddressSection(existingCompany, sourceCompany, currentCompany, setCurrentCompany),
      profileSection(existingCompany, sourceCompany, currentCompany, setCurrentCompany),
      generalDetailsSection(existingCompany, existingTags, sourceCompany, sourceTags, currentCompany, currentTags, setCurrentCompany, setCurrentTags),
      financialDetailsSection(existingCompany, sourceCompany, currentCompany, setCurrentCompany),
      contactDetailsSection(existingCompany, sourceCompany, currentCompany, setCurrentCompany),
      venueDetailsSection(venueSectionHidden, existingVenue, sourceVenue, currentVenue, setCurrentVenue),
      bankDetailsSection(existingBank, sourceBank, currentBank, setCurrentBank),
    ]}
  />
}

export default CompanyMergeApp;